/**
 *
 * User Journey Tracker
 *
 */

import { useEffect, useState, PropsWithChildren } from "react";
import { useMutation } from "@tanstack/react-query";
import { useTracking } from "react-tracking";

import api from "api/api";
import AuthService from "utils/authService";

export function LegacyViewCountTrackerProvider(props: PropsWithChildren) {
  const [enabled, setEnabled] = useState(false);
  const [formData, setFormData] = useState({ view: {} });

  interface ViewsApi {
    views: {
      createViews: (data: unknown) => unknown;
    };
  }

  const postViews = () => {
    return Promise.resolve(
      (api as unknown as ViewsApi).views.createViews(formData),
    );
  };

  const postViewsMutation = useMutation({
    mutationFn: postViews,
    retry: 0,
    onSettled: () => {
      setEnabled(false);
    },
  });

  useEffect(() => {
    if (!enabled) {
      return;
    }
    postViewsMutation.mutate();
  }, [enabled, postViewsMutation]);

  const postTrackedData = (trackedData: unknown) => {
    if (
      AuthService.isUserInStore() &&
      trackedData != null &&
      typeof trackedData === "object" &&
      "data" in trackedData
    ) {
      // @ts-expect-error -- legacy shit
      trackedData.data.user_id = AuthService.getUserData()?.user_id;
      // @ts-expect-error -- legacy shit
      setFormData({ view: trackedData.data });

      setEnabled(true);
    } else {
      setEnabled(false);
    }

    return trackedData;
  };

  const { Track } = useTracking(
    {},
    {
      process: (trackedData) => postTrackedData(trackedData),
      dispatch: (trackedData) => postTrackedData(trackedData),
    },
  );

  return <Track>{props.children}</Track>;
}
